<div class="lm-get-started-wrapper" [class.lm-module-highlight]="state.selectedCategory === '_start_'" (click)="startedClicked()">
  <svg soho-icon [icon]="'home'" class="lm-get-started-icon"></svg>
  <p class="lm-get-started-text">{{ 'Home' | translate }}</p>
</div>
<div class="lm-facade-modules-wrapper scrollable">
  @for (facade of moduleFacades; track facade.module) {
    <span class="lm-facade-module-item" [class.lm-module-highlight]="state.selectedCategory === facade.module" (click)="moduleClicked(facade)"><p>{{ facade.title }}</p></span>
  } @empty {
      @if(moduleFacades) {
          <span class="lm-facade-module-item"><p>{{ 'Facade_ExplorerModulesEmptyMessage' | translate }}</p></span>
      }
  }
</div>